<template>
    <div class="u-page-wrapper pb-56">
        <div class="mb-16">
            <div class="u-page-headline mb-24">
                <div class="u-flex u-flex--space-between u-flex--vertical-center">
                    <h2 class="u-size-body">
                        <i class="el-icon-document" aria-hidden="true"></i>
                        Öl-Typ
                    </h2>

                    <el-button type="text" icon="el-icon-edit" circle @click="showEditTypeModal = true" />
                </div>
            </div>

            <p class="u-size-14">
                <span v-if="oilInfo && oilInfo.type">{{ oilInfo.type }}</span>
                <span v-else class="text-primary">Du hast noch keinen Typ erfasst.</span>
            </p>
        </div>

        <div class="mb-16">
            <div class="u-page-headline u-flex u-flex--space-between u-flex--vertical-center">
                <h2 class="u-size-body">
                    <i class="el-icon-check" aria-hidden="true"></i>
                    Öl-Check
                </h2>

                <el-button type="text" icon="el-icon-plus" circle @click="showAddCheckModal = true" />
            </div>

            <hint class="mt-16">Jeden Monat oder bei jedem 3. Tanken prüfen.</hint>

            <inspection-card
                v-if="oilCheckDates.length"
                :dates="oilCheckDates"
                v-bind="oilCheckInfo"
                class="mt-16"
            />
            <p v-else class="u-size-14 mt-16 text-primary">Du hast noch keinen Öl-Check hinzugefügt.</p>
        </div>

        <div class="mb-16">
            <div class="u-page-headline u-flex u-flex--space-between u-flex--vertical-center">
                <h2 class="u-size-body">
                    <i class="el-icon-refresh" aria-hidden="true"></i>
                    Öl-Wechsel
                </h2>

                <el-button type="text" icon="el-icon-plus" circle @click="showAddChangeModal = true" />
            </div>

            <hint class="mt-16">Alle 25.000 km oder 1x im Jahr wechseln - 150€.</hint>

            <inspection-card
                v-if="oilChangeDates.length"
                :dates="oilChangeDates"
                v-bind="oilChangeInfo"
                class="mt-16"
            />
            <p v-else class="u-size-14 mt-16 text-primary">Du hast noch keinen Öl-Wechsel hinzugefügt.</p>
        </div>

        <edit-oil-type-modal
            v-if="oilInfo"
            v-model="showEditTypeModal"
            :item="oilInfo"
            @reload="loadOilInfo"
        />

        <add-oil-check-modal
            v-if="oilCheckDates"
            v-model="showAddCheckModal"
            @reload="loadOilChecks"
        />
    </div>
</template>

<script>
import Appwrite from '@/assets/appwrite'
import Hint from '@/components/Hint'
import InspectionCard from '@/components/modals/InspectionCard'
import EditOilTypeModal from '@/components/modals/EditOilTypeModal.vue'
import AddOilCheckModal from '@/components/modals/AddOilCheckModal.vue'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'

export default {
    components: { AddOilCheckModal, Hint, InspectionCard, EditOilTypeModal },

    data () {
        return {
            oilInfo: null,
            oilCheckDates: [],
            oilChangeDates: [],
            showAddCheckModal: false,
            showAddChangeModal: false,
            showEditTypeModal: false,
        }
    },

    computed: {
        oilCheckInfo () {
            return {
                interval: { months: 1 },
                warningDiff: 7,
                dangerDiff: 1,
            }
        },

        oilChangeInfo () {
            return {
                interval: { years: 1 },
                warningDiff: 90,
                dangerDiff: 30,
            }
        },
    },

    watch: {
        showAddChangeModal () {
            // @TODO remove
            if (this.showAddChangeModal) {
                this.showAddChangeModal = false
                alert('Not implemented')
            }
        },
    },

    mounted () {
        this.reload()
    },

    methods: {
        reload () {
            this.loadOilInfo()
            this.loadOilChecks()
        },

        async loadOilInfo () {
            try {
                const { documents } = await Appwrite.databases.listDocuments(Appwrite.DB_NAME, 'oil_type')
                const doc = documents[0] || null
                if (!doc) return

                this.oilInfo = { ...doc, id: doc.$id }
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
            }
        },

        async loadOilChecks () {
            try {
                const { documents } = await Appwrite.databases.listDocuments(Appwrite.DB_NAME, 'oil_check')
                if (!documents.length) return

                this.oilCheckDates = documents.map(x => ({ ...x, id: x.$id, date: format(parseISO(x.date), 'yyyy-MM-dd'), created: x.$createdAt }))
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
